import SubscriptionPlanDetailsForm from './SubscriptionPlanDetailsForm';

export default SubscriptionPlanDetailsForm;
